import z from "zod";

/**
 * The rating scales the `sample_cans` family draws on.
 *
 * The same rule as every family's sets: one set per distinct list of valid
 * values, a number where an aggregate may sum and a string where it may not, and
 * an id of namespace, version and word. Needs and strengths are separate sets
 * although both run 0–3, because a 2 means something different on each and an
 * aggregate that summed them together would be adding unlike things.
 */

/** A need: none, watch or prevent, act, act immediately or intensively. */
export const need = z.literal([0, 1, 2, 3]).meta({ id: "sample_cans.v1.need" });

/** The same four levels, where the item does not apply to this young person. */
export const needOrNotApplicable = z
  .literal([0, 1, 2, 3, "not_applicable"])
  .meta({ id: "sample_cans.v1.need_or_not_applicable" });

/**
 * A strength: a centrepiece, useful, identified but in need of building, not
 * yet identified. Lower is stronger, as lower is less need on the needs scale,
 * but the two are not the same scale.
 */
export const strength = z
  .literal([0, 1, 2, 3])
  .meta({ id: "sample_cans.v1.strength" });

/**
 * Whether a potentially traumatic or adverse experience has happened: no
 * evidence of it, or yes. A number, so a count of the experiences a young
 * person has had is a sum an aggregate may take.
 */
export const experience = z
  .literal([0, 1])
  .meta({ id: "sample_cans.v1.experience" });
